<h2 class="mat-h2">
  <ng-content></ng-content>
</h2>
